import React from 'react';
import { useSelector } from 'react-redux';

import ui from 'modules/ui';
import type { State } from 'types';
import useOddsStatisticFetcher from './useOddsStatisticFetcher';

const {
    selectors: { selectOddsStatisticView },
} = ui;

const Fetcher: React.FC = () => {
    useOddsStatisticFetcher();

    return null;
};

const OddsStatisticFetcher: React.FC = () => {
    const isOddStatisticsEnabled = useSelector(
        (state: State) => selectOddsStatisticView(state).show
    );

    return isOddStatisticsEnabled ? <Fetcher /> : null;
};

export default OddsStatisticFetcher;
